export function MatIcon({ mainClassName, fillClassName }) {
    return (
        <svg
            width={34}
            height={34}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 34 34"
        >
            <path
                d="M29.264 14.712c-.153-.04-.302-.076-.453-.115l-.638-.161a50.416 50.416 0 00-2.444-.534l-.638-.12a49.412 49.412 0 00-8.023-.78L16.431 13a45.47 45.47 0 00-8.023.686l-.637.12a33.163 33.163 0 00-2.445.572l-.637.186c-.301.093-.468.152-.48.157A.32.32 0 004 15.02v4.653h.637v-4.425c.7-.231 3.13-.966 6.77-1.362 3.953-.43 10.174-.535 17.455 1.379v4.408h.638V15.02a.318.318 0 00-.236-.308zM28.862 19.673H4v.637H29.5v-.637h-.638z"
                fill="#000"
                className={fillClassName}
            />
        </svg>
    );
}

export function ChairIcon({ mainClassName, fillClassName }) {
    return (
        <svg
            width={34}
            height={34}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 34 34"
        >
            <path
                d="M27.053 12.121H24.19l1.316-5.318c.165-.68.01-1.387-.423-1.937A2.257 2.257 0 0023.3 4H9.701c-.7 0-1.35.316-1.784.866a2.258 2.258 0 00-.423 1.939l1.316 5.316H5.947c-.607 0-1.168.276-1.539.755a1.933 1.933 0 00-.345 1.68l2.718 10.482a.325.325 0 00.314.243h2.229L8.24 29.54a.324.324 0 00.628.16l1.125-4.42h13.015l1.124 4.42a.324.324 0 10.628-.16l-1.083-4.26h2.229c.147 0 .276-.1.313-.243l2.718-10.482c.152-.588.026-1.2-.345-1.68a1.933 1.933 0 00-1.539-.755zM8.426 5.267c.31-.393.774-.618 1.275-.618h13.598c.5 0 .965.225 1.274.618.31.393.42.898.303 1.382l-3.264 13.187c-4.072.943-9.157.169-10.228-.013L8.124 6.65a1.613 1.613 0 01.302-1.384zm19.883 9.126l-2.655 10.24H7.345l-2.654-10.24a1.29 1.29 0 01.23-1.12 1.29 1.29 0 011.026-.503H8.97l1.835 7.413c.03.123.13.217.254.24.165.032 2.796.527 5.922.527 1.617 0 3.367-.133 4.976-.53a.323.323 0 00.237-.237l1.834-7.413h3.024c.405 0 .779.183 1.026.503.248.32.332.728.23 1.12z"
                fill="#000"
                className={fillClassName}
            />
            <path
                d="M12.751 10.062c.18 0 .325-.145.325-.324v-.971a.324.324 0 10-.65 0v.97c.001.18.146.325.325.325zM16.5 10.062c.18 0 .325-.145.325-.324v-.971a.324.324 0 10-.65 0v.97c0 .18.146.325.325.325zM20.25 10.062c.178 0 .324-.145.324-.324v-.971a.324.324 0 10-.65 0v.97c0 .18.146.325.325.325zM14.626 14.374c.18 0 .325-.145.325-.324v-.97a.324.324 0 10-.65 0v.97c0 .179.146.324.325.324zM18.375 14.374c.18 0 .325-.145.325-.324v-.97a.324.324 0 10-.65 0v.97c.001.179.146.324.325.324z"
                fill="#000"
                className={fillClassName}
            />
        </svg>
    );
}

export function WardrobeIcon({ mainClassName, fillClassName }) {
    return (
        <svg
            width={34}
            height={34}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 34 34"
        >
            <path
                d="M8.378 2A.378.378 0 008 2.378V31.86c0 .209.17.378.378.378h16.528c.209 0 .378-.169.378-.378V2.38A.378.378 0 0024.906 2H8.378zm7.886 29.481H8.757V2.756h7.507V31.48zm8.264 0H17.02V2.756h7.508l-.001 28.725z"
                fill="#000"
                className={fillClassName}
            />
            <path
                d="M11.443 17.538h2.135a.378.378 0 000-.756h-2.135a.378.378 0 000 .756zM19.706 17.538h2.136a.378.378 0 000-.756h-2.136a.378.378 0 000 .756z"
                fill="#000"
                className={fillClassName}
            />
        </svg>
    );
}

export function SofaIcon({ mainClassName, fillClassName }) {
    return (
        <svg
            width={34}
            height={34}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 34 34"
        >
            <path
                d="M30.334 12.663h-1.296c-.144 0-.285.009-.424.023v-1.793c0-1.632-1.928-4.069-4.037-4.069H8.999c-2.109 0-3.616 2.696-3.616 4.328l.004 1.604a4.672 4.672 0 00-.915-.093h-.805C1.645 12.663 0 13.936 0 15.5v12.035c0 .187.19.338.425.338h2.623v2.79c0 .186.19.337.426.337.234 0 .425-.151.425-.338v-2.79h26.41v2.79c0 .187.19.338.425.338.234 0 .425-.151.425-.338v-2.79h2.416c.235 0 .425-.15.425-.337V15.5c0-1.564-1.645-2.837-3.666-2.837zm-24.097.338l-.003-1.849C6.234 9.892 7.36 7.5 9 7.5h15.576c1.64 0 3.188 2.133 3.188 3.393v1.966c-1.304.414-2.207 1.447-2.207 2.69v2.621H8.139V15.5c0-1.07-.77-2.004-1.905-2.487l.003-.012zm1.902 5.844h17.418v3.21H8.139v-3.21zm25.012 8.353H.85V15.501c0-1.193 1.263-2.163 2.817-2.163h.805c1.553 0 2.817.97 2.817 2.163v6.892c0 .186.19.337.425.337h18.267c.235 0 .425-.15.425-.337v-6.844c0-1.26 1.131-2.21 2.631-2.21h1.296c1.553 0 2.817.97 2.817 2.162v11.697z"
                fill="#000"
                className={fillClassName}
            />
        </svg>
    );
}

export function TableIcon({ mainClassName, fillClassName }) {
    return (
        <svg
            width={34}
            height={34}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 34 34"
        >
            <path
                d="M31.625 14.194H6.069V9.157H9.01a.375.375 0 00.374-.413l-.66-6.407A.375.375 0 008.35 2H3.035a.375.375 0 00-.373.337l-.66 6.407a.375.375 0 00.373.413h2.943v5.037H2.375A.375.375 0 002 14.57v3.668c0 .208.168.376.375.376h1.177v13.01a.375.375 0 10.75 0V18.614h16.294v8.095c0 .207.168.375.375.375h8.727v4.542a.375.375 0 10.75 0V18.613h1.177a.375.375 0 00.375-.375v-3.67a.375.375 0 00-.375-.374zM3.374 2.75h4.638l.583 5.657H2.79l.583-5.657zm17.972 23.583v-3.425H29.7v3.425h-8.353zm8.353-4.175h-8.353v-3.545H29.7v3.545zm1.552-4.295H2.75v-2.919h28.5v2.92z"
                fill="#000"
                className={fillClassName}
            />
        </svg>
    );
}


export function PedestalIcon({ mainClassName, fillClassName }) {
    return (
        <svg
            width={34}
            height={34}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 34 34"
        >
            <path
                d="M16.36 12.033h1.28a.375.375 0 100-.75h-1.28a.375.375 0 100 .75zM17.64 23.179h-1.28a.375.375 0 100 .75h1.28a.375.375 0 100-.75zM16.36 17.976h1.28a.375.375 0 100-.75h-1.28a.375.375 0 100 .75z"
                fill="#000"
                className={fillClassName}
            />
            <path
                d="M31.625 4H2.375A.375.375 0 002 4.375v4.112c0 .207.168.375.375.375h.571v17.735c0 .207.168.375.375.375h1.273v2.757a.375.375 0 10.75 0v-2.757h23.312v2.757a.375.375 0 10.75 0v-2.757h1.273a.375.375 0 00.375-.376V8.862h.57A.375.375 0 0032 8.487V4.375A.375.375 0 0031.625 4zm-1.322 16.209H3.696v-5.204h26.607v5.204zM3.696 26.221v-5.264h26.607v5.264H3.696zm26.607-11.967H3.696V8.863h26.607v5.393zm.947-6.143H2.75V4.75h28.5v3.362z"
                fill="#000"
                className={fillClassName}
            />
        </svg>
    );
}


export function HangerIcon({ mainClassName, fillClassName }) {
    return (
        <svg
            width={34}
            height={34}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 34 34"
        >
            <path
                d="M10.378 6.812a.376.376 0 00-.378.375v2.245c0 .207.17.375.378.375h6.244V31.25h-3.671a.376.376 0 00-.378.375c0 .207.17.375.378.375h8.098a.376.376 0 00.377-.375.376.376 0 00-.377-.375h-3.671V14.11h6.244a.376.376 0 00.378-.375V11.49a.376.376 0 00-.378-.375.376.376 0 00-.377.375v1.87h-5.867V5.852h3.421a.376.376 0 00.378-.375V3.233a.376.376 0 00-.378-.376.376.376 0 00-.377.376v1.87h-3.044V2.374A.376.376 0 0017 2a.376.376 0 00-.378.375v6.682h-5.867v-1.87a.376.376 0 00-.377-.374z"
                fill="#000"
                className={fillClassName}
            />
        </svg>
    );
}


export function HallwayIcon({ mainClassName, fillClassName }) {
    return (
        <svg
            width={34}
            height={34}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 34 34"
        >
            <path
                d="M28.687 16.446h-1.352a1.41 1.41 0 00.311-.775l.287-3.748a.312.312 0 00-.312-.337H24.33a.313.313 0 00-.311.337l.286 3.748c.022.293.137.559.31.775h-1.588c.128-.18.212-.395.23-.63l.246-3.216a.312.312 0 00-.311-.336h-2.825a.313.313 0 00-.312.336l.246 3.217c.018.234.102.448.23.63h-9.587v-.452c0-.552-.444-1.001-.994-1.012l.428-2.64a1.25 1.25 0 00-.317-.94.961.961 0 00-.707-.319h-.17v-.59h3.361a.313.313 0 00.311-.338l-.415-4.87A.312.312 0 0012.128 5H5.612a.312.312 0 00-.312.286l-.416 4.87a.313.313 0 00.312.339h3.361v.59h-.17a.961.961 0 00-.707.317c-.227.244-.342.587-.314.97l.425 2.61c-.55.012-.995.461-.995 1.013v.451H4.313A.312.312 0 004 16.76v2.16c0 .173.14.313.313.313h.537v8.213c0 .173.14.313.312.313h.815l.3 1.977a.312.312 0 00.31.265H8.85a.313.313 0 00.31-.265l.3-1.977h14.088l.3 1.977a.312.312 0 00.31.265h2.264a.313.313 0 00.309-.265l.3-1.977h.724c.172 0 .312-.14.312-.313v-8.213h.62c.173 0 .313-.14.313-.313v-2.16a.312.312 0 00-.313-.312zm-1.403-4.235l-.261 3.412a.803.803 0 01-.797.738h-.502a.803.803 0 01-.797-.738l-.26-3.412h2.617zm-4.43.678l-.221 2.88a.644.644 0 01-.64.592h-.43a.644.644 0 01-.64-.592l-.22-2.88h2.15zM5.897 5.625h5.943l.363 4.245H5.536l.362-4.245zm2.24 6.204a.344.344 0 01.249-.12h.966c.114 0 .198.065.25.12a.622.622 0 01.154.442l-.441 2.71h-.893l-.437-2.682a.633.633 0 01.151-.47zm-.717 4.167a.39.39 0 01.39-.39h2.117a.39.39 0 01.39.39v.45H7.421v-.45zm-1.947 7.582h6.847v3.555H5.474v-3.555zm14.58 0v3.555h-7.108v-3.555h7.107zM8.582 29.375H6.854l-.245-1.617h2.218l-.245 1.617zm17.571 0h-1.727l-.246-1.617H26.4l-.246 1.617zm-5.474-2.242v-3.555h6.763v3.555H20.68zm6.763-4.18H5.475v-3.721h21.967v3.721zm.933-4.347H4.625v-1.535h23.75v1.535z"
                fill="#000"
                className={fillClassName}
            />
        </svg>
    );
}

export function KitchenIcon({ mainClassName, fillClassName }) {
    return (
        <svg
            width={34}
            height={34}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 34 34"
        >
            <path
                d="M23.56 22.182h1.1a.325.325 0 100-.65h-1.1a.325.325 0 100 .65zM23.44 7.39h1.099a.325.325 0 100-.65h-1.1a.325.325 0 100 .65zM10.583 6.74h-1.1a.325.325 0 100 .65h1.1a.325.325 0 100-.65zM23.56 25.348h1.1a.325.325 0 100-.65h-1.1a.325.325 0 100 .65zM24.66 27.864h-1.1a.325.325 0 100 .65h1.1a.325.325 0 100-.65zM14.361 24.24c.18 0 .325-.144.325-.324v-1.1a.325.325 0 10-.65 0v1.1c0 .18.145.325.325.325zM10.142 22.491a.325.325 0 00-.325.325v1.1a.325.325 0 10.65 0v-1.1a.325.325 0 00-.325-.325z"
                fill="#000"
                className={fillClassName}
            />
            <path
                d="M29.655 16.412H4.325a.325.325 0 00-.325.325v3.56c0 .18.145.326.325.326h.587v9.032c0 .18.145.325.325.325h23.506c.179 0 .324-.146.324-.325v-9.032h.587c.18 0 .325-.146.325-.325v-3.561a.325.325 0 00-.325-.325zm-24.093 4.21h6.365v8.708H5.562v-8.707zm22.856 5.589h-8.827v-2.47h8.827v2.47zm-9.477 3.119h-6.365v-8.707h6.365v8.707zm.65 0v-2.47h8.827v2.47H19.59zm8.827-6.238H19.59v-2.47h8.827v2.47zm.912-3.12H4.65v-2.91h24.68v2.91zM29.675 4H4.345a.325.325 0 00-.324.325V9.79c0 .18.145.325.324.325h25.33c.18 0 .325-.145.325-.325V4.325A.324.324 0 0029.675 4zM4.67 4.65h12.016v4.816H4.67V4.65zm24.68 4.816H17.335V4.65H29.35v4.817z"
                fill="#000"
                className={fillClassName}
            />
        </svg>
    );
}

export function DecorIcon({ mainClassName, fillClassName }) {
    return (
        <svg
            width={34}
            height={34}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 34 34"
        >
            <path
                d="M11.306 5a.306.306 0 00-.306.306v23.88c0 .169.137.306.306.306h10.388c.169 0 .306-.137.306-.307V5.306A.306.306 0 0021.694 5H11.306zm10.082.612v8.98h-9.776v-8.98h9.776zM11.612 28.88V15.205h9.776v13.674h-9.776z"
                fill="#000"
                className={fillClassName}
            />
            <path
                d="M16.5 13.325a3.286 3.286 0 003.283-3.283A3.286 3.286 0 0016.5 6.76a3.286 3.286 0 00-3.282 3.282 3.286 3.286 0 003.282 3.283zm0-5.953a2.673 2.673 0 012.67 2.67 2.673 2.673 0 01-2.67 2.67 2.673 2.673 0 01-2.67-2.67 2.673 2.673 0 012.67-2.67z"
                fill="#000"
                className={fillClassName}
            />
            <path
                d="M16.5 10.348h1.53a.306.306 0 000-.613h-1.224V8.597a.306.306 0 10-.613 0v1.445c0 .169.138.306.307.306zM19.052 16.94H13.95a.306.306 0 00-.306.306v9.694c0 .17.137.306.306.306h5.102c.17 0 .306-.137.306-.306v-9.694a.306.306 0 00-.306-.306zm-2.551 6.122a.862.862 0 010 1.722.862.862 0 010-1.722zm2.245 3.572h-4.49v-9.082h1.939v4.931a1.475 1.475 0 00-1.167 1.44c0 .813.66 1.474 1.473 1.474.813 0 1.473-.661 1.473-1.473 0-.708-.501-1.3-1.167-1.44v-4.932h1.94v9.082z"
                fill="#000"
                className={fillClassName}
            />
        </svg>
    );
}

export function LinenIcon({ mainClassName, fillClassName }) {
    return (
        <svg
            width={34}
            height={34}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 34 34"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M29.759 16.896c-.155-.041-.308-.077-.462-.117l-.65-.165a51.382 51.382 0 00-2.492-.544v-3.602A1.47 1.47 0 0024.687 11h-6.544c-.465 0-.874.22-1.143.558A1.46 1.46 0 0015.857 11H9.313a1.47 1.47 0 00-1.468 1.468v3.505a33.802 33.802 0 00-2.493.582l-.65.19c-.307.095-.477.156-.49.16A.325.325 0 004 17.21v4.744h.65v-4.512c.714-.235 3.191-.985 6.901-1.388 4.032-.438 10.374-.546 17.799 1.406v4.494H30V17.21a.325.325 0 00-.241-.314zM8.495 15.85a46.36 46.36 0 018.18-.7v-2.682a.819.819 0 00-.818-.818H9.313a.819.819 0 00-.818.818v3.382zm8.83-.697c2.475.036 5.225.264 8.18.795v-3.48a.819.819 0 00-.818-.818h-6.544a.819.819 0 00-.818.817v2.686z"
                fill="#000"
                className={fillClassName}
            />
            <path d="M29.35 21.954H4v.65H30v-.65h-.65z" fill="#000" className={fillClassName} />
        </svg>
    );
}


export function FloorCoveringIcon({ mainClassName, strokeClassName }) {
    return (
        <svg
            width={34}
            height={34}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 34 34"
        >
            <path
                d="M16.019 7.906L2 16l16.232 9.372 14.019-8.094L19.213 9.75l-3.194-1.845z"
                stroke="#000"
                strokeWidth={0.7}
                className={strokeClassName}
            />
        </svg>
    );
}


export function LivingRoomIcon({ mainClassName, fillClassName }) {
    return (
        <svg
            width={34}
            height={34}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 34 34"
        >
            <path
                d="M16.398 25.538h1.1a.325.325 0 100-.65h-1.1a.325.325 0 100 .65zM25.384 24.889h-1.1a.325.325 0 100 .65h1.1a.325.325 0 100-.65zM9.614 24.889h-1.1a.325.325 0 100 .65h1.1a.325.325 0 100-.65zM17.499 20.406h-1.1a.325.325 0 100 .65h1.1a.325.325 0 100-.65zM24.284 21.056h1.1a.325.325 0 100-.65h-1.1a.325.325 0 100 .65zM8.515 21.056h1.099a.325.325 0 100-.65h-1.1a.325.325 0 100 .65z"
                fill="#000"
                className={fillClassName}
            />
            <path
                d="M29.674 15.904H18.372v-1.438h7.448c.18 0 .325-.146.325-.325V4.325A.325.325 0 0025.82 4H8.268a.325.325 0 00-.325.325v9.816c0 .18.145.325.325.325h7.213v1.438H4.325A.325.325 0 004 16.23v2.247c0 .18.145.325.325.325h.559v8.542c0 .18.145.325.325.325h.847l.312 2.056c.024.159.16.276.322.276h2.354c.16 0 .297-.117.322-.276l.312-2.056H24.33l.312 2.056c.024.159.16.276.321.276h2.355c.16 0 .297-.117.321-.276l.312-2.056h.753c.18 0 .325-.145.325-.325V18.8h.645c.18 0 .325-.145.325-.325V16.23a.325.325 0 00-.325-.325h-.001zM8.592 4.65h16.903v9.166H8.592V4.65zm7.539 9.816h1.591v1.438h-1.591v-1.438zM12.654 18.8v3.87H5.533v-3.87h7.12zm.65 3.87v-3.87h7.391v3.87h-7.391zm7.391.65v3.697h-7.391V23.32h7.391zm-15.162 0h7.12v3.697h-7.12V23.32zm3.23 6.03H6.969l-.256-1.683H9.02l-.255 1.682zm18.276 0h-1.797l-.255-1.683h2.307l-.255 1.682zm-5.694-2.333v-3.697h7.034v3.697h-7.034zm7.034-4.347h-7.034v-3.87h7.034v3.87zm.97-4.52H4.65v-1.597h24.7v1.597z"
                fill="#000"
                className={fillClassName}
            />
        </svg>
    );
}

export function BedroomIcon({ mainClassName, fillClassName }) {
    return (
        <svg
            width={34}
            height={34}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 34 34"
        >
            <path
                d="M18.497 15.646c-.1-.027-.197-.05-.296-.075V8.558a.208.208 0 00-.208-.208H2.658a.208.208 0 00-.208.208v6.99c-.197.061-.306.1-.314.103a.208.208 0 00-.136.196v5.952c0 .115.093.208.208.208h1.43l-.695 2.734a.208.208 0 00.403.103l.722-2.837h12.515l.722 2.837a.208.208 0 00.403-.103l-.695-2.734h1.43a.208.208 0 00.208-.209v-5.951a.208.208 0 00-.154-.202zm-15.63-6.88h14.918v6.7a32.922 32.922 0 00-1.596-.35V12.81a.941.941 0 00-.94-.94h-4.192a.935.935 0 00-.732.357.935.935 0 00-.731-.357H5.403a.941.941 0 00-.94.94v2.244a21.69 21.69 0 00-1.597.373V8.766zm7.25 5.762a29.684 29.684 0 00-5.239.448v-2.167c0-.288.236-.523.524-.523h4.191c.29 0 .524.235.524.523v1.719zm5.655.51a32.28 32.28 0 00-5.238-.508v-1.72c0-.29.234-.524.523-.524h4.191c.29 0 .524.234.524.523v2.23zm-8.936.068c2.582-.28 6.644-.35 11.399.9v2.879H2.416v-2.89c.457-.15 2.044-.63 4.42-.889zm-4.42 6.484V19.3h15.819v2.29H2.416zM30.857 17.753h-.619c.08-.1.132-.22.142-.355l.132-1.716a.143.143 0 00-.143-.154h-1.508a.143.143 0 00-.142.154l.13 1.716c.011.134.064.256.143.355h-.727a.574.574 0 00.105-.288l.113-1.473a.143.143 0 00-.143-.154h-1.293a.143.143 0 00-.143.154l.113 1.473a.574.574 0 00.105.288h-4.39v-.206a.465.465 0 00-.455-.464l.196-1.209a.572.572 0 00-.146-.43.44.44 0 00-.323-.146h-.078v-.27h1.54a.143.143 0 00.142-.156l-.19-2.23a.143.143 0 00-.143-.13H20.29a.143.143 0 00-.143.13l-.19 2.23a.143.143 0 00.142.156h1.54v.27h-.079a.44.44 0 00-.323.146.578.578 0 00-.144.443l.194 1.196a.465.465 0 00-.455.464v.206h-1.137a.143.143 0 00-.143.143v.99c0 .078.064.142.143.142h.246v3.761c0 .08.064.144.143.144h.373l.138.905c.01.07.07.121.14.121h1.038c.07 0 .13-.051.141-.121l.138-.905h6.451l.137.905c.011.07.071.121.142.121h1.037c.07 0 .13-.051.141-.121l.138-.905h.331a.143.143 0 00.143-.144v-3.76h.284a.143.143 0 00.143-.144v-.989a.143.143 0 00-.143-.143zm-.642-1.94l-.12 1.563a.368.368 0 01-.365.338h-.23a.368.368 0 01-.365-.338l-.119-1.562h1.199zm-2.03.311l-.1 1.319a.295.295 0 01-.293.271h-.197a.295.295 0 01-.293-.271l-.1-1.319h.984zm-7.763-3.326h2.721l.166 1.944h-3.053l.166-1.944zm1.025 2.84a.157.157 0 01.114-.054h.443c.052 0 .09.03.114.055.05.052.075.133.07.202l-.201 1.241h-.409l-.2-1.228a.29.29 0 01.07-.215zm-.328 1.909c0-.099.08-.179.179-.179h.97c.098 0 .178.08.178.179v.206h-1.327v-.206zm-.891 3.472h3.135v1.627h-3.135V21.02zm6.676 0v1.627h-3.255V21.02h3.255zm-5.253 2.654h-.791l-.113-.74h1.016l-.112.74zm8.046 0h-.791l-.113-.74h1.016l-.112.74zm-2.507-1.027V21.02h3.097v1.627H27.19zm3.097-1.913H20.228v-1.705h10.059v1.705zm.427-1.99H19.84v-.704h10.875v.703z"
                fill="#000"
                className={fillClassName}
            />
        </svg>
    );
}


export function BedIcon({ mainClassName, fillClassName }) {
    return (
        <svg
            width={34}
            height={34}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 34 34"
        >
            <path
                d="M28.768 15.954c-.149-.04-.295-.074-.444-.112V5.312A.313.313 0 0028.012 5H4.988a.313.313 0 00-.312.313v10.496c-.296.09-.46.15-.472.154a.313.313 0 00-.204.293v8.937c0 .172.14.312.313.312H6.46L5.416 29.61a.313.313 0 00.606.155l1.083-4.26h18.79l1.084 4.26a.313.313 0 00.605-.155l-1.043-4.105h2.147c.172 0 .312-.14.312-.313v-8.936a.313.313 0 00-.231-.302zM5.301 5.625h22.398v10.058a49.499 49.499 0 00-2.396-.523v-3.464c0-.778-.634-1.411-1.412-1.411H17.6c-.446 0-.84.212-1.1.537a1.403 1.403 0 00-1.098-.537H9.11c-.779 0-1.412.633-1.412 1.411v3.37a32.467 32.467 0 00-2.397.56v-10zm10.886 8.65a44.58 44.58 0 00-7.865.674v-3.253c0-.434.353-.787.786-.787h6.293c.434 0 .786.353.786.787v2.58zm8.491.767a48.452 48.452 0 00-7.866-.763v-2.583c0-.434.353-.787.787-.787h6.292c.434 0 .787.353.787.787v3.346zm-13.417.102c3.876-.42 9.975-.524 17.114 1.352v4.322H4.625v-4.339c.686-.226 3.069-.946 6.636-1.335zM4.625 24.88v-3.438h23.75v3.438H4.625z"
                fill="#000"
                className={fillClassName}
            />
        </svg>
    );
}

export function OfficeIcon({ mainClassName, fillClassName }) {
    return (
        <svg
            width={34}
            height={34}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 34 34"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.378 15.686h4.208a.304.304 0 00.303-.314l-.227-5.959A4.56 4.56 0 0017.074 5c-2.49 0-4.506 1.939-4.587 4.412l-.228 5.96a.3.3 0 00.303.314h4.816zm-.304-10.082a3.957 3.957 0 00-3.981 3.83l-.216 5.648h8.393l-.215-5.647a3.957 3.957 0 00-3.981-3.831z"
                fill="#000"
                className={fillClassName}
            />
            <path
                d="M7.81 13.414a.303.303 0 100 .604h.874v1.776h.608v-1.776h.875a.303.303 0 100-.604H7.81z"
                fill="#000"
                className={fillClassName}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.213 18.976v.92c0 .707.579 1.283 1.29 1.283h5.267v2.26l-3.422 1.958a1.56 1.56 0 00-1.94-.322 1.539 1.539 0 00.37 2.825 1.548 1.548 0 001.873-1.98l3.12-1.784v1.959c-.71.14-1.248.765-1.248 1.511 0 .85.696 1.542 1.551 1.542s1.55-.691 1.55-1.542c0-.746-.536-1.37-1.246-1.51v-1.96l3.12 1.784a1.548 1.548 0 001.873 1.98 1.54 1.54 0 00.369-2.825 1.56 1.56 0 00-1.94.322l-3.422-1.957v-2.261h5.1c.711 0 1.29-.576 1.29-1.284v-.904l-.001-.608-.606.014v1.499c0 .375-.307.68-.684.68H11.504a.682.682 0 01-.684-.68v-1.5l-.604-.03-.003.61zm1.723 8.342a.945.945 0 00.716-.093.936.936 0 00-.472-1.752.941.941 0 00-.816 1.407.937.937 0 00.572.438zm10.032-1.845a.936.936 0 00-.472 1.751.943.943 0 001.288-.344.942.942 0 00-.816-1.406zm-4.894 3.072c.52 0 .943-.421.943-.938a.942.942 0 00-.943-.939c-.52 0-.944.421-.944.939 0 .517.423.938.944.938z"
                fill="#000"
                className={fillClassName}
            />
            <path
                d="M25.464 14.018h.874a.303.303 0 100-.604h-2.357a.303.303 0 100 .604h.875v1.756h.608v-1.756z"
                fill="#000"
                className={fillClassName}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M28.846 15.251H5.302a.302.302 0 00-.302.303v2.957c0 .167.135.302.302.302h.947v10.488a.302.302 0 10.604 0V18.813h20.442V29.3a.302.302 0 10.604 0V18.813h.947a.302.302 0 00.302-.303v-2.957a.302.302 0 00-.302-.302zM5.604 18.21h22.94v-2.353H5.604v2.353z"
                fill="#000"
                className={fillClassName}
            />
        </svg>
    );
}


export function ChildrenRoomIcon({ mainClassName, fillClassName }) {
    return (
        <svg
            width={34}
            height={34}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 34 34"
        >
            <path
                d="M28.216 4c-.984 0-1.784.8-1.784 1.784v1.57c-1.566-.325-8.8-1.685-15.299-.561a2.03 2.03 0 00-1.979-1.534h-.3c-.494 0-.945.185-1.288.486A1.785 1.785 0 005.784 4C4.8 4 4 4.8 4 5.784v23.89c0 .18.146.326.325.326h2.918c.18 0 .325-.145.325-.325V26.6h18.864v3.074c0 .18.146.325.325.325h2.918c.18 0 .325-.145.325-.325V5.784C30 4.8 29.2 4 28.216 4zM7.568 23.067v-2.52c0-.688.577-1.248 1.286-1.248h.3c.764 0 1.386.604 1.386 1.346v2.422H7.568zm18.864-12.74v2.235H7.568v-2.234h18.864zm-15.299 9.856a2.03 2.03 0 00-1.979-1.534h-.3c-.494 0-.944.184-1.286.484v-5.921h18.864v7.531c-1.566-.325-8.8-1.684-15.299-.56zm.057.65c6.619-1.162 14.058.321 15.242.575v1.66H11.19v-2.236zM26.432 8.017v1.66H11.19V7.443c6.619-1.161 14.058.322 15.242.575zM8.854 5.91h.3c.765 0 1.386.604 1.386 1.346v2.422H7.568v-2.52c0-.688.577-1.248 1.286-1.248zM6.918 29.35H4.65V5.784c0-.625.509-1.134 1.134-1.134.625 0 1.134.51 1.134 1.134V29.35zm.65-3.399v-2.234h18.864v2.235H7.568zm21.782 3.4H27.08V5.783a1.135 1.135 0 012.269 0V29.35z"
                fill="#000"
                className={fillClassName}
            />
        </svg>
    );
}

export function UniversalIcon({ mainClassName, fillClassName }) {
    return (
      <svg
        width={34}
        height={34}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={mainClassName}
        viewBox="0 0 34 34"
      >
        <path
          d="M8.378 2A.378.378 0 008 2.378V31.86c0 .209.17.378.378.378h16.528c.209 0 .378-.169.378-.378V2.38A.378.378 0 0024.906 2H8.378zm7.886 29.481H8.757V2.756h7.507V31.48zm8.264 0H17.02V2.756h7.508l-.001 28.725z"
          fill="#000"
          className={fillClassName}
        />
        <path
          d="M11.443 17.538h2.135a.378.378 0 000-.756h-2.135a.378.378 0 000 .756zM19.706 17.538h2.136a.378.378 0 000-.756h-2.136a.378.378 0 000 .756z"
          fill="#000"
          className={fillClassName}
        />
      </svg>
    );
  }

